import { render, staticRenderFns } from "./StudySchedule.vue?vue&type=template&id=4fa28e58&scoped=true"
import script from "./StudySchedule.vue?vue&type=script&lang=js"
export * from "./StudySchedule.vue?vue&type=script&lang=js"
import style0 from "./StudySchedule.vue?vue&type=style&index=0&id=4fa28e58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa28e58",
  null
  
)

export default component.exports